<template>
    <div>
      <apexchart width="500" type="pie" :options="options" :series="series"></apexchart>
    </div>
</template>
<script>
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)
export default {
    name: 'PieChart',
    data: () => {
        return {
            series: [44, 55, 13, 43, 22],
            options: {
              labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
              theme: {
                monochrome: {
                  enabled: true
                }
              },
              responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 150
                    },
                    legend: {
                      position: 'bottom'
                    }
                  }
              }]
            }
        }
    },
}
</script>